import styled from "styled-components";
import React from "react";

const StyledNetworkImage = styled.img.attrs(({ src, altText }) => ({
    src: src,
    alt: altText || src,
}))`
    width: ${({ size, width }) => size || width || "18px"};
    height: ${({ size, height }) => size || height || "18px"};
    border-radius: ${({ borderRadius }) => borderRadius || "0px"};
    visibility: ${({ isDisabled }) => (isDisabled ? "hidden" : "visible")};
    cursor: ${({ cursor }) => cursor || "inherit"};
`;

function CustomNetworkImage({ src, altText, size, width, height, borderRadius, isDisabled, cursor, onError }) {
    return (
        <>
            <StyledNetworkImage
                src={src}
                altText={altText}
                size={size}
                width={width}
                height={height}
                borderRadius={borderRadius}
                isDisabled={isDisabled}
                cursor={cursor}
                onError={onError}
            />
        </>
    );
}

export default CustomNetworkImage;
